import React from 'react';
import {
    Container,
    Text,
    Row,
    Col,
    className,
    SocialIcons,
} from 'design-system';
import style from './styles.module.scss';

export default function PostMetaSection({ metas, url, title }) {
    return (
        <section {...className(`${style.wrapper}`)}>
            <Container>
                <Row>
                    <Col offset={{ lg: 1 }} col={{ xs: 8, md: 9, lg: 4 }}>
                        <Text className={`body ${style.metas}`}>{metas}</Text>
                    </Col>
                    <Col className="text-right" col={{ xs: 4, md: 3, lg: 2 }}>
                        <SocialIcons
                            icons={[
                                {
                                    url: `https://twitter.com/intent/tweet?url=${encodeURI(
                                        url,
                                    )}&text=${encodeURI(title)}`,
                                    kind: 'twitter',
                                },
                                {
                                    url: `http://www.linkedin.com/shareArticle?mini=true&url=${encodeURI(
                                        url,
                                    )}&title=${encodeURI(title)}`,
                                    kind: 'linkedin',
                                },
                            ]}
                        />
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
